import ContentModal from './container'

export default ContentModal
